import styled from 'styled-components';
import { isMobile } from '../../../utils/device';

const Container1 = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 16px;
`;
const GreyBox = styled.div`
  height: ${(props) => props.h}px;
  width: ${(props) => props.h}px;
  background-color: #f0f0f0;
  border-radius: ${(props) => props.br * 4}px;
  min-width: 160px;
  margin-bottom: 16px;
`;

function AppLoader() {
  return (
    <div
      className="w-[100%] flex flex-col  overflow-auto "
      style={{ height: 'fit-content' }}
    >
      <div
        className={`flex border-bottom p-4 justify-between `}
        style={{ marginTop: isMobile() ? '50px' : '0px' }}
      >
        <GreyBox h={20} w={160} br={1} style={{ width: '30%' }} />
        <GreyBox h={20} w={160} br={1} style={{ width: '10%' }} />
      </div>
      <div className="p-4">
        <Container1>
          <GreyBox h={20} w={160} br={1} style={{ width: '30%' }} />
          <GreyBox h={100} w={160} br={3} style={{ width: '100%' }} />
          <GreyBox h={20} w={160} br={1} style={{ width: '30%' }} />
          <GreyBox h={100} w={160} br={3} style={{ width: '100%' }} />
        </Container1>
      </div>
    </div>
  );
}

export default AppLoader;
